/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useMemo } from 'react';
import type {
  NotificationBannerBlock,
  Platform,
} from '../models/homepageBlockTypes';
import { useHomepageBlock } from './useHomepage';
import { HOMEPAGE_BLOCK_IDS } from '../models/homepageBlockTypes';

export interface NotificationData {
  text: string;
  actionTitle?: string;
  actionUrl?: string;
}

export const useNotificationData = (
  platform?: Platform,
): NotificationData | null => {
  const block = useHomepageBlock<NotificationBannerBlock>(
    HOMEPAGE_BLOCK_IDS.NOTIFICATION_BANNER,
    { platform },
  );

  return useMemo(() => {
    if (!block?.data?.notificationBanner) return null;

    const { notificationBanner } = block.data;

    return {
      text: notificationBanner.text,
      actionTitle: notificationBanner.callToAction?.text,
      actionUrl: notificationBanner.callToAction?.url,
    };
  }, [block]);
};
